import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import './styles/global-styles.scss';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* <Route exact path={routes.appliancePackage.path} element={<routes.appliancePackage.component />} /> */}
        <Route exact path={routes.package.path} element={<routes.package.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};